import { get } from "lodash";
import { RegionType, Region } from "@tvg/ts-types/Geolocation";

export const getRegionByType = (regions: Region[], type: RegionType) =>
  regions.find((region) => region.type === type) || get(regions, 0, undefined);
